import { Modal as MaterialModal } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'MuiModal';

const classes = {
  root: `.${PREFIX}-root`,
  backdrop: `.${PREFIX}-backdrop`,
};

export const StyledMaterialModal = styled(MaterialModal)`
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: none;
  }

  ${classes.backdrop} {
    background-color: var(--white-with-opacity-5);
    backdrop-filter: blur(10px);
  }
`;
